export default __webpack_public_path__ + "static/Group18-b4d1d91ec9c8ee0c16dd75122dbfe533.svg";